<template>
  <div>
    <page-header
      :page="headerPage"
      :actions="headerActions"
      left-side-class="col-xl-8"
      right-side-class="col-xl-4 d-flex align-items-end justify-content-end pb-2"
    />

    <div>
      <filter-manager
        ref="filter"
        :display-advanced="false"
        v-model="filter.model"
        :filters="filtersHeader"
        class="filter-manager_extended"
        search-container-class="search-btn"
        @search="onSearchHandler()"
      />

      <custom-separator
        class="my-3 custom-separator"
        text="Resultados de Libros"
      />

      <div v-if="hasResults">
        <result-row
          v-for="(item, index) in results"
          :key="index"
          :item="item"
          :readingMediums="readingMediums"
          :publishers="publishers"
          :authors="authors"
          :grades="grades"
          :reasons="reasons"
          :centers="centers"
          @open="handlerOpen"
          @close="handlerClose"
          @refresh="refresh"
          @reload-seleted-items="onSearchSelectedHandler"
        />

        <pagination
          v-if="pagination.totalItemCount > pagination.pageSize"
          :data="pagination"
          :page-size="pagination.pageSize"
          @pagination-go-page="onPageChange"
        />
      </div>

      <custom-result-not-found
        v-if="!hasResults"
        text="No hay Resultados de libros"
      />

      <custom-separator
        class="my-3 custom-separator"
        text="Libros Seleccionados"
      />

      <result-row-selected
        v-for="(item, index) in selectedResults"
        :key="index"
        :item="item"
        @refresh="onSearchSelectedHandler()"
      />

      <custom-result-not-found
        v-if="!selectedResults.length"
        text="No hay Libros Seleccionados"
      />
    </div>
  </div>
</template>
<script>
import PageHeader from "PageHeader";
import ActionButton from "ActionButton";
import storeMixin from "@/mixin/storeGenerator";
import alertMixin from "@/mixin/alert.mixin";
import inventoryCatalogService from "@/services/api/inventorycatalog.api";
import inventoryOrderBooksService from "@/services/api/inventoryOrderBooks.api";
import FilterManager from "FilterManager";
import CustomSeparator from "custom-separator";
import CustomResultNotFound from "custom-result-not-found";
import Pagination from "pagination";
import academicService from "@/services/api/academicUtils.api.js";
import ResultRow from "./components/ResultRow.vue";
import ResultRowSelected from "./components/ResultRowSelected.vue";
import { name as appModuleName } from "@/modules/app/store/index";
import { mapGetters } from "vuex";
import EduEspCode from "@/utils/constants/eduEspCode";
import EduEspTextCodes from "@/utils/constants/EduEspTextCodes";
import * as bookService from "@/modules/books-requests/api";
import locationService from "@/services/api/location.api";

const DEFAULT_PAGE_SIZE = 5;

export default {
  name: "InventoryOrderBooksAdd",
  components: {
    PageHeader,
    ActionButton,
    FilterManager,
    CustomSeparator,
    CustomResultNotFound,
    Pagination,
    ResultRow,
    ResultRowSelected,
    Pagination
  },
  mixins: [alertMixin, storeMixin],
  data: () => ({
    loading: false,
    selectedItems: [],
    grades: [],
    publishers: [],
    readingMediums: [],
    authors: [],
    reasons: [],
    centers: [],
    filter: {
      model: {
        catalog: null,
        subject: null
      },
      options: {
        catalogs: [],
        subjects: []
      }
    },
    pagination: {
      count: 0,
      currentPage: 1,
      pageCount: 1,
      totalItemCount: 0,
      pageSize: DEFAULT_PAGE_SIZE
    },
    results: [],
    selectedResults: []
  }),
  computed: {
    ...mapGetters(appModuleName, {
      isMobile: "getIsMobileDensity"
    }),
    headerPage() {
      return {
        icon: "fas fa-book-open",
        title: "Crear Pedido",
        routes: ["Inicio", "Libros", "Crear Pedido"]
      };
    },
    headerActions() {
      return [
        {
          text: "Regresar",
          icon: "fas fa-arrow-circle-left",
          variant: "outline-success",
          click: () => this.$router.go(-1)
        },
        {
          text: "Someter",
          icon: "fas fa-flag",
          variant: "success",
          click: () => this.handlerSubmit()
        }
      ];
    },
    hasResults() {
      return Boolean(this.results?.length);
    },
    hasSelectedItems() {
      return Boolean(this.selectedItems?.length);
    },
    filtersHeader() {
      return [
        {
          name: "catalog",
          component: "CustomDropDown",
          options: this.filter.options.catalogs,
          value: this.filter.model.catalog,
          placeholder: "Título del Libro",
          fieldName: "name",
          fieldKey: "id",
          class: "col-sm-6 col-md-6 ml-0 mr-0",
          clearable: true
        },
        {
          name: "subject",
          component: "CustomDropDown",
          options: this.filter.options.subjects,
          value: this.filter.model.subject,
          placeholder: "Materia",
          fieldName: "name",
          fieldKey: "id",
          class: "col-sm-6 col-md-6 ml-0 mr-0",
          clearable: true
        }
      ];
    },
    showNotResults() {
      return this.result.length == 0;
    }
  },
  async mounted() {
    await Promise.allSettled([
      this.getBookCatalogs(),
      this.getSubjects(),
      this.getGrades(),
      this.getAuthors(),
      this.getPublishers(),
      this.getReasons(),
      this.getReadingMediums(),
      this.onSearchSelectedHandler(),
      this.getCenters()
    ]);
  },
  methods: {
    async onSearchHandler(page = 1) {
      const { catalog, subject } = this.filter.model;
      const { pageSize } = this.pagination;

      const { data } = await inventoryOrderBooksService.searchForAdd({
        catalogId: catalog?.id,
        subjectId: subject?.id,
        currentPage: page,
        pageSize
      });

      this.results = data.data.map(x => ({
        ...x,
        isOpen: false,
        selected: false,
        disabled: false
      }));

      this.pagination = {
        pageSize: DEFAULT_PAGE_SIZE,
        totalItemCount: data.totalItemCount,
        pageCount: data.pageCount,
        currentPage: data.currentPage,
        count: data.count
      };
    },
    async onSearchSelectedHandler() {
      const { catalog, subject } = this.filter.model;

      const { data } = await inventoryOrderBooksService.searchForSelectedAdd({
        catalogId: catalog?.id,
        subjectId: subject?.id
      });

      this.selectedResults = data;
    },
    async onPageChange(page) {
      this.onSearchHandler(page);
    },
    async getSubjects() {
      const { data } = await academicService.getEduEsp({
        codetype: EduEspCode.CatlibSubject
      });
      this.filter.options.subjects = data;
    },
    async getReadingMediums() {
      const readingMediums = await academicService.getEduEsp({
        codetype: EduEspCode.CatlibReadingmedium
      });
      this.readingMediums = readingMediums.data;
    },
    async getBookCatalogs() {
      const { data } = await inventoryCatalogService.getKeyValue();
      this.filter.options.catalogs = data;
    },
    async getGrades() {
      const { data } = await academicService.getGrades();
      this.grades = data;
    },
    async getReasons() {
      const { data } = await inventoryOrderBooksService.getReasons();
      this.reasons = data;
    },
    async getPublishers() {
      const { data } = await bookService.getBooksPublishers();
      this.publishers = data.filter(
        e => e.name.toUpperCase() !== EduEspTextCodes.NotAvailable
      );
    },
    async getCenters() {
      const { data } = await locationService.getCenters({
        academicYearId: this.currentAcademicYear().id
      });
      this.centers = data;
    },
    async getAuthors() {
      const { data } = await bookService.getBooksAuthors();
      this.authors = data.filter(
        e => e.name.toUpperCase() !== EduEspTextCodes.NotAvailable
      );
    },
    async handlerOpen(item) {
      this.results
        .filter(x => x.id != item.id)
        .forEach(x => {
          x.isOpen = false;
          x.disabled = true;
        });

      item.isOpen = true;
      item.disabled = false;
    },
    handlerClose(item) {
      this.results
        .filter(x => x.id != item.id)
        .forEach(x => {
          x.disabled = false;
        });

      item.isOpen = false;
      item.disabled = false;
    },
    async refresh() {
      await this.onSearchHandler(this.pagination.currentPage);
    },
    async handlerSubmit() {
      if (!this.selectedResults.length) {
        this.ShowToast(
          "Error",
          "Debe seleccionar al menos un libro para someter",
          "error"
        );
        return;
      }

      let confirmation = await this.ShowCancelModal(
        "Atención",
        `¿Está seguro que desea someter los libros seleccionados?`,
        "Si",
        "No"
      );
      if (!confirmation) return !isValid;

      const { orderId } = this.selectedResults[0];

      const { data } = await inventoryOrderBooksService
        .submit(orderId)
        .catch(e => {
          this.ShowToast({
            message: e.response.data.message,
            variant: "danger"
          });
        });

      if (data) {
        this.ShowToast(
          "Éxito",
          "La solicitud se ha sometido correctamente.",
          "success"
        );
        this.$router.go(-1);
      }
    }
  },
  destroyed() {
    this.persistData();
  },
  beforeRouteEnter(_, from, next) {
    const routes = [];
    next(async vm => {
      if (routes.includes(from.name)) {
        vm.recoveryData();
        await vm.onPageChange(1);
      } else {
        vm.shouldRecovery = false;
      }
    });
  }
};
</script>
<style scoped lang="scss">
::v-deep .font-weight-bold {
  font-weight: 700 !important;
}

.actions-dropdown ::v-deep #dropdownMenuButton {
  color: #11291b !important;
}
</style>
